import gql from 'graphql-tag';

export const GET_ALL_CONVERSATION = gql`
query{
  conversationAll{
    data{
      id
      user{id name email profile_image{url} }
      company{id name logo{url}}
      CountUnReadMessages
      messages(first : 100){data{
        id
        user{id name email}
        text
        created_at
      }}
    }
  }
}
`
export const CONVERSATION_READ =  gql`
mutation( $id : Int){
  conversationsRead(Inputs: {
    id : $id
  }){
    Status{
      code
      message
    }
  }
}
`
export const GET_CONVERSATION = gql`
query($id : Int !){
  conversationFind(id: $id){
      id
      user{id name email profile_image{url} }
      company{id name logo{url}}
      CountUnReadMessages
      messages(first : 1000){data{
        id
        user{id name email}
        text
        created_at
      }}
  }
}`
